<template>
    <div class="p-3" style="overflow: scroll">
        <div class="row">
            <div class="col col-auto pr-0">
                <button
                    class="fields-group__title"
                    data-toggle="collapse"
                    data-target="#collapse-sidefilter"
                    aria-expanded="false"
                    @click="toggleFilterComponent"
                >
                    <i class="icofont-filter"></i>
                </button>
            </div>
        </div>
        <!--/ row -->

        <task-filter-component
            @filter="getFilteredTasks"
            v-if="showFilterComponent"
            :new-page="newPage"
        ></task-filter-component>

        <div class="scroll mt-2" id="task-list">
            <span
                class="task"
                v-for="filteredTask in filteredTasks.data"
                :key="filteredTask.id"
                :draggable="true"
                @dragstart="dragStart($event, filteredTask.id)"
            >
                <div class="task__progress">
                    <div class="bar" :style="{ width: `${filteredTask.progress}%` }"></div>

                    <span>{{ filteredTask.planned_hours }}/{{ filteredTask.estimated_hours }}</span>
                </div>
                <div class="d-flex flex-column w-75 py-2 task__title">
                    <template v-if="filteredTask.client !== null">
                        <p class="pretitle m-0">
                            <span class="icontext">
                                <span class="icontext__icon mr-1">
                                    <i :class="getIconForRelatable(filteredTask)"></i>
                                </span>

                                <span
                                    class="icontext__text"
                                    :class="{
                                        'font-italic': filteredTask.relatable.deleted_at,
                                    }"
                                >
                                    {{ filteredTask.client.title }}
                                </span>
                            </span>
                        </p>
                    </template>
                    <template v-if="filteredTask.relatable_type == 'project'">
                        <p class="pretitle m-0">
                            <span class="icontext">
                                <span class="icontext__icon mr-1">
                                    <i class="icofont-chart-flow-2"></i>
                                </span>

                                <span class="icontext__text">
                                    {{ filteredTask.project.title }}
                                </span>
                            </span>
                        </p>
                    </template>
                    <p class="m-0 font-weight-bold">{{ filteredTask.title }}</p>

                    <template v-if="filteredTask.relatable_type === 'project' && filteredTask.project && filteredTask.project.description && showDescriptionInCards">
                        <vue-markdown
                            class="description-style"
                            :source="filteredTask.project.description"
                        ></vue-markdown>
                    </template>


                </div>
            </span>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

var qs = require('qs');
import store from '../../../stores';
import VueMarkdown from "vue-markdown-render";

export default {
    components: {
        VueMarkdown,
        'task-filter-component': require('./filter/TaskFilterComponent.vue').default,
    },
    props: {},
    data() {
        return {
            filteredTasks: {
                total: 0,
                per_page: 20,
                from: 1,
                to: 0,
                current_page: 1,
                data: [],
            },
            showFilterComponent: false,
            dragInfo: {
                taskId: null,
            },
            newPage: false,
            isFiltering: false,
        };
    },
    computed:{
        ...mapState('planning', {
            showDescriptionInCards: (state) => state.showDescriptionInCards,
        }),
    },
    methods: {
        getFilteredTasks(params = null, resetFilter = false) {
            if (resetFilter) {
                this.filteredTasks.current_page = 1;
                if (!params) {
                    this.isFiltering = false;
                }
            }
            if (params) {
                this.isFiltering = true;
            }
            let url = `${route('task.filtered-tasks')}?page=${this.filteredTasks.current_page}`;
            axios
                .get(url, {
                    params,
                    paramsSerializer: (params) => {
                        return qs.stringify(params, { encode: false });
                    },
                })
                .then((response) => {
                    if (response.data.filteredTasks.current_page > 1) {
                        this.filteredTasks.data = this.filteredTasks.data.concat(
                            response.data.filteredTasks.data,
                        );
                    } else {
                        this.filteredTasks = response.data.filteredTasks;
                    }
                })
                .catch((response) => {})
                .then(() => {});
        },
        toggleFilterComponent() {
            this.showFilterComponent = !this.showFilterComponent;
        },
        getIconForRelatable(task) {
            switch (task.relatable_type) {
                case 'contact':
                    return 'icofont-user-alt-3';
                case 'company':
                    return 'icofont-building-alt';
                case 'project':
                    if (task.relatable.clientable_type == 'contact') {
                        return 'icofont-user-alt-3';
                    }
                    if (task.relatable.clientable_type == 'company') {
                        return 'icofont-building-alt';
                    }
            }
        },
        taskListControlPanelScroller() {
            // Detect when scrolled to bottom.
            const listElm = document.getElementById('task-list');
            listElm.addEventListener('scroll', (e) => {
                this.newPage = false;
                if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                    if (this.filteredTasks.current_page < this.filteredTasks.last_page) {
                        this.filteredTasks.current_page += 1;
                        if (this.isFiltering) {
                            this.newPage = true;
                        } else {
                            this.getFilteredTasks();
                        }
                    }
                }
            });
        },
        dragStart(event, taskid) {
            //remove draginfo
            this.$store.commit('planning/resetDragStartInfo');
            event.dataTransfer.setData('taskId', taskid);
        },
    },
    mounted() {
        this.getFilteredTasks();
        this.taskListControlPanelScroller();
    },
};
</script>


<style >
.scroll {
    overflow: hidden scroll;
    height: 100%;
}
</style>

